/*
 * Copyright (c) 2021 Anton Bagdatyev (Tonix)
 *
 * Permission is hereby granted, free of charge, to any person
 * obtaining a copy of this software and associated documentation
 * files (the "Software"), to deal in the Software without
 * restriction, including without limitation the rights to use,
 * copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the
 * Software is furnished to do so, subject to the following
 * conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
 * OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
 * HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
 * WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
 * OTHER DEALINGS IN THE SOFTWARE.
 */

import extendMap from "./extendMap";

/**
 * @type {number}
 */
let itemIdCounter = 0;

export default function setSelectedUniqueKey($el, instance) {
  const self = instance;
  const checkedKey = $el.data(self.options.checkedKeyDataAttributeName);
  if (self.selectedMap.get(checkedKey)) {
    self.selectedMap = extendMap(self.selectedMap.unset(checkedKey));
  }
  const key = $el.data(self.options.keyDataAttributeName) || ++itemIdCounter;
  $el.data(self.options.checkedKeyDataAttributeName, key);
  const value = $el.val();
  const newMap = self.selectedMap.set({
    [key]: {
      $el,
      key,
      value: value || void 0,
      i: $el.index(self.options.checkboxes)
    }
  });
  self.selectedMap = extendMap(newMap);
}
